module.exports = __webpack_public_path__ + "img/logo.336ed3f6.svg";